import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Pagination } from '../models/pagination';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../models/api-response';
import { List } from '../models/list';
import { Media } from '../models/media';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  endpoint: string;

  constructor(private baseService: BaseService) {
    this.endpoint = 'media';
  }

  public getAll(productId: string, pagination?: Pagination): Observable<ApiResponse<List<Media>>> {
    return this.baseService.getAll<List<Media>>(this.endpoint, { params: Object.assign({ productId: productId }, pagination) })
    .pipe(map(data => {
      data.payload.elements.forEach(e => {
        if (!e.id) {
          e.id = e._id;
          delete e._id;
        }
      });
      return data;
    }));
  }

  public get(id: string): Observable<ApiResponse<Media>> {
    return this.baseService.get<Media>(`${this.endpoint}/${id}`);
  }

  public add(media: Media): Observable<ApiResponse<Media>> {
    return this.baseService.add<Media>(this.endpoint, media);
  }

  public update(id: string, media: Media): Observable<ApiResponse<Media>> {
    return this.baseService.update<Media>(`${this.endpoint}/${id}`, media);
  }

  public delete(id: string): Observable<ApiResponse<Media>> {
    return this.baseService.delete<Media>(`${this.endpoint}/${id}`);
  }

  public updateAsset(id: string, file: File): Observable<ApiResponse<Media>> {
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.baseService.add<Media>(`${this.endpoint}/${id}/asset`, formData, headers);
  }

}
